<template>
    <svg class="mark" viewBox="0 0 100 100" overflow="visible" data-mark="hop3" aria-hidden="true">
        <polygon class="hop__triangle" stroke-width="3" stroke-linejoin="round" points="50,62 74,94 26,94" />
        <path class="hop__dome" d="M18 62 A32 32 0 0 1 82 62 Z" />
        <circle class="hop__ball" cx="50" cy="19" r="11" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .mark {
        @apply block size-full overflow-visible;
    }

    .hop__triangle {
        fill: var(--tonal-teal-strong);
        stroke: var(--tonal-teal-strong);
    }

    .hop__dome {
        fill: var(--tonal-teal-base);
    }

    .hop__ball {
        fill: var(--tonal-purple-strong);
        transform-box: fill-box;
        transform-origin: 50% 100%;
        animation: hop 1.05s infinite;
    }
}

@keyframes hop {
    0% {
        transform: translateY(0) scale(1.08, 0.92);
        animation-timing-function: ease-out;
    }

    8% {
        transform: translateY(-2px) scale(1, 1);
        animation-timing-function: cubic-bezier(0.1, 0.7, 0.4, 1);
    }

    52% {
        transform: translateY(-9px) scale(1, 1);
        animation-timing-function: cubic-bezier(0.6, 0, 0.9, 0.5);
    }

    94% {
        transform: translateY(-1px) scale(1, 1);
        animation-timing-function: ease-in;
    }

    100% {
        transform: translateY(0) scale(1.08, 0.92);
    }
}

@media (prefers-reduced-motion: reduce) {
    .hop__ball {
        animation: none;
    }
}
</style>
